import React, { useEffect } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import cx from 'classnames';
import { createPortal } from 'react-dom';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

export const Portal = ({ children }) => {
  let modalRoot;
  let el;

  // @ts-ignore
  if (process.browser) {
    modalRoot = document.getElementById('modal');
    el = document.createElement('div');
  }

  useEffect(() => {
    if (modalRoot) {
      modalRoot.appendChild(el);

      return () => {
        modalRoot.removeChild(el);
      };
    }
  }, [children, el, modalRoot]);

  // @ts-ignore
  if (!process.browser) return null;

  return createPortal(children, el);
};

const Modal = ({ children, toggle, isOpened }) => {
  const classes = useStyles();

  const escHandler = (e) => {
    if (e.key === 'Escape' && isOpened) {
      toggle();
    }
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', escHandler, false);
    }
  });

  return (
    <Portal>
      {isOpened && (
        <div className={classes.container} onClick={toggle}>
          <div className={classes.content}>
            <div className={cx(classes.closeBtn, 'close-btn')} onClick={toggle}>
              <CloseIcon style={{ color: colorsPalette.white }} />
            </div>
            {children}
          </div>
        </div>
      )}
    </Portal>
  );
};

export default Modal;
